import router from "../../router";
import {defaultLocale} from "../../translate";
import { formatNumber } from "../../utils/filters.js"

const url = import.meta.env.VITE_APP_API_TRADE
const serverRunning = typeof window === "undefined"

const BRAND_NAME = import.meta.env.VITE_APP_BRAND_NAME
const LISTING_TYPE_CFD = 1
const LISTING_TYPE_CRYPTO = 2
const LISTING_TYPE_COMMODY = 3
const LISTING_TYPE_FIAT = 0

export {LISTING_TYPE_CFD, LISTING_TYPE_CRYPTO, LISTING_TYPE_COMMODY, LISTING_TYPE_FIAT}
export default {

    actions: {
        async fetchTools({commit, getters, dispatch}, withAddition = true) {
            commit('SET_IS_TOOLS_LOADING', true)
            try {
                const {getCurrencies} = getters
                const  resJson = await fetch(`${url}/currency/directions`)
                const res = await resJson.json()

                if(res.code === 200) {
                    dispatch('fetchToolSettingsList')
                    commit('SET_TOOLS', res.data.items)
                    commit('SET_FAVORITE_CURRENCIES', res.data.items)

                    const pairName = router.currentRoute.value.params.pair || res.data.items[0].direction
                    if(withAddition) {
                        dispatch('fetchToolData', pairName)
                    }
                    const {getInjectCurrency} = getters

                    if(!getInjectCurrency) {
                        if(!getCurrencies.length) {
                            let currencies = await dispatch('fetchCurrencies')
                            commit('SET_CURRENCIES', currencies)
                            commit('SET_TOOLS_CURRENCIES', currencies)
                        } else  {
                            commit('SET_TOOLS_CURRENCIES', getCurrencies)
                        }
                    }

                } else {
                    commit('SET_TRADE_LIST_LOADING_STATUS', 'error')
                }
                commit('SET_IS_TOOLS_LOADING', false)
                return res
            } catch (e) {
                commit('SET_IS_TOOLS_LOADING', false)
                return []
            }
        },
        async updateToolsData({commit, dispatch}) {
            try {
                const  resJson = await fetch(`${url}/currency/directions`)
                const res = await resJson.json()
                if(res.code === 200) {
                    commit('SET_TOOLS_DATA', res.data.items)
                }
                return res
            } catch (e) {
                return []
            }
        },

        async fetchToolSettingsList({commit, getters}, tool ) {

            const {getToolsSetting} = getters
            if (getToolsSetting[tool] !== undefined) {
                return
            }
            const  resJson = await fetch(`${url}/currency/directions-settings/list`)
            const res = await resJson.json()
            if(res.code === 200) {
                commit('SET_TOOLS_SETTING_LIST', res.data.items)
                return  res.data
            }
            return null
        },
        async fetchToolSetting({commit, getters}, tool ) {
            return
            const {getToolsSetting} = getters
            if (getToolsSetting[tool] !== undefined) {
                return
            }
            const  resJson = await fetch(`${url}/currency/directions-settings/${tool}`)
            const res = await resJson.json()
            if(res.code === 200) {
                commit('SET_TOOLS_SETTING', {tool: tool, setting: res.data})
                return {tool: tool, setting: res.data}
            }
            return null
        },
        async fetchToolData({commit, getters, dispatch}, tool) {
            const {getAllTools, getCurrentToolSetting, getAppLanguage} = getters
            const foundIndex = getAllTools.findIndex(e => e.direction === tool)
            if(foundIndex != -1) {
                commit('SET_TOOL_INDEX', {index: foundIndex, lang: getAppLanguage})
               // await dispatch('fetchToolSetting', tool)
                if(!serverRunning) {
                    document.title = formatNumber(getAllTools[foundIndex].price, getCurrentToolSetting.decimal_price, true).toLocaleString('en') + ' | ' + getAllTools[foundIndex].base_asset + '' +
                        getAllTools[foundIndex].quote_asset + ' | '+BRAND_NAME+' | Online Trading Provider'
                }
                dispatch('fetchOrders')
                dispatch('fetchTrades')
            } else {
                router.push('/404')
            }
        },
        async fetchQuoteHistory({commit, getters}, params) {
            try {
                return  await fetch(`${url}/quot/history?symbol=${params.direction}&resolution=5&from=${params.from}&to=${params.to}`).
                then(response => response.json())
                    .then(result => {
                        return result
                    })
            } catch (e) {
                return []
            }
        },
        async fetchOrderCount({commit, getters}, tool) {
            try {
                return  await fetch(`${url}/order/count/${tool}`).
                then(response => response.json())
                    .then(result => {
                        if(result.data.bot_buy !== undefined && result.data.bot_sell !== undefined) {
                            commit('SET_TOOL_ORDER_COUNT', {
                                tool: tool,
                                buy_count: result.data.bot_buy,
                                sell_count: result.data.bot_sell
                            })
                        }
                        return result
                    })
            } catch (e) {
                return []
            }
        },
        async initTradeReload({commit}) {
            commit('SET_TRADE_RELOAD')
        },
        async setCurrentToolLeverage({commit}, data) {
            commit('SET_CURRENT_TOOL_LEVERAGE', data)
        },
    },
    mutations: {
        SET_CURRENT_TOOL_LEVERAGE(state, data) {
            state.userDirectionSetting[data.direction] = {
                leverage: data.leverage,
            };
            localStorage.setItem('userDirectionSetting', JSON.stringify(state.userDirectionSetting));
        },
        SET_IS_TOOLS_LOADING(state, value) {
            state.isToolsLoading = value
        },
        SET_TOOLS(state, tools) {
            state.injectCurrency = false
            state.tools = tools
        },
        SET_TOOLS_CURRENCIES(state, currencies) {
            state.tools.forEach((tool) => {
                const foundBaseAsset = currencies.find(e => tool.base_asset == e.name)
                if(foundBaseAsset !== null) {
                    tool.base_asset_data = foundBaseAsset;
                }
                const foundQuoteAsset = currencies.find(e => tool.quote_asset == e.name)
                if(foundQuoteAsset !== null) {
                    tool.quote_asset_data = foundQuoteAsset;
                }
            })
            state.injectCurrency = true
        },

        SET_TOOLS_DATA(state, tools) {
            tools.forEach((el) => {
                let found =  state.tools.find(e => e.direction == el.direction)
                if(found !== undefined) {
                    found.price = el.price
                }
            });
        },
        SET_TOOL_ORDER_COUNT(state, data) {
            let found =  state.tools.find(e => e.direction == data.tool)
            if(found !== undefined) {
                found.buy_count = data.buy_count
                found.sell_count = data.sell_count
            }
        },

        SET_FAVORITE_CURRENCIES(state, tools) {
            let currencies = []
            for (let i = 0; i < tools.length; i++) {
                if(currencies.findIndex(e => e === tools[i].base_asset) === -1) {
                    currencies.push(tools[i].base_asset)
                }
                if(currencies.findIndex(e => e === tools[i].quote_asset) === -1) {
                    currencies.push(tools[i].quote_asset)
                }
                if(currencies.length > 10) {
                    break
                }
                state.favoriteCurrencyList = currencies
            }
        },
        SET_TOOLS_SETTING(state, data) {
            let property = {}
            property[data.tool] = data.setting
            state.toolsSetting =  {...state.toolsSetting, ...property}
        },
        SET_TOOLS_SETTING_LIST(state, data) {

            state.toolsSetting = data.reduce((acc, data) => {
                acc[data.direction] = {
                    decimal_price: data.decimal_price,
                    decimal_volume: data.decimal_volume,
                    min_volume: data.min_volume,
                    max_volume: data.max_volume,
                    fee_maker: data.fee_maker,
                    fee_taker: data.fee_taker,
                    lot_size: data.lot_size,
                    tick_size: data.tick_size,
                    max_leverage: data.max_leverage,
                    contract_size: data.contract_size,
                    market_session: data.market_session,
                    market_status: data.market_status,
                };
                return acc;
            }, {});
        },
        SET_TOOL_INDEX(state, data) {
            state.toolIndex = data.index
        },
        SOCKET_ONMESSAGE(state, message) {
            let decimal_price = 2

            const foundIndex = state.tools.findIndex(e => e.direction === message.d)
            if(foundIndex !== -1) {
                if (message.t === "dl") {
                    if (message.p > state.tools[foundIndex].price) {
                        state.priceIndicator = 1
                    } else {
                        state.priceIndicator = -1
                    }
                    state.tools[foundIndex].volume_24 = state.tools[foundIndex].volume_24 + message.v
                    //state.tools[foundIndex].pricePrev = state.tools[foundIndex].price
                    state.tools[foundIndex].price = message.p
                    state.tools[foundIndex].volume = state.tools[foundIndex].volume - message.v
                }
                /*if (message.t === "os" || message.t === "ob") {
                    state.tools[state.toolIndex].volume = state.tools[state.toolIndex].volume + message.v
                }*/

                if(!serverRunning && router.currentRoute._value.path.includes('trade') && state.toolIndex !== -1 && state.tools[ state.toolIndex].direction == message.d) {
                    let setting
                    if ((setting = state.toolsSetting[state.tools[foundIndex].direction]) !== undefined) {
                        decimal_price = setting.decimal_price
                    }
                    document.title = formatNumber(state.tools[state.toolIndex].price, decimal_price, true).toLocaleString('en') + ' | ' + state.tools[state.toolIndex].base_asset + '' + state.tools[state.toolIndex].quote_asset +
                        ' | '+BRAND_NAME+' | Online Trading Provider'
                }
            }
            if(message.t === "dr") {
                const foundIndex = state.tools.findIndex(e => e.direction === message.d)
                if(foundIndex != -1) {
                    let priceIndicator = 0;
                    if(message.p >= state.tools[foundIndex].price) {
                        priceIndicator = 1
                        //state.priceIndicator = 1
                    } else {
                        priceIndicator = -1
                        state.priceIndicator = -1
                    }
                    state.tools[foundIndex].priceIndicator = priceIndicator
                    state.tools[foundIndex].pricePrev = state.tools[foundIndex].price
                    state.tools[foundIndex].price = message.p
                    if(message.v > 0) {
                        state.tools[foundIndex].volume = message.v
                    }
                    if(message.c > 0) {
                        state.tools[foundIndex].change = message.c
                    }
                }
            }
        },
        SET_TRADE_RELOAD(state) {
            state.tradeReaload++
        },

    },
    state: {
        tools: [],
        isToolsLoading: false,
        toolsSetting: {},
        userDirectionSetting: localStorage.getItem('userDirectionSetting') ? JSON.parse(localStorage.getItem('userDirectionSetting')) : {},
        toolIndex: -1,
        priceIndicator: 0,
        favoriteCurrencyList: [],
        tradeReaload: 0,
        injectCurrency: false
    },
    getters: {
        getAllTools:(state) => state.tools,
        getIsToolsLoading:(state) => state.isToolsLoading,
        getActiveTool:(state) => state.toolIndex === - 1 || state.tools.length === 0? null : state.tools[state.toolIndex],
        getActiveToolIndex:(state) => state.toolIndex,
        toolIndex:(state) => state.toolIndex,
        priceIndicator: (state) => state.priceIndicator,
        getToolsSetting: (state) => state.toolsSetting,
        getCurrentToolSetting: (state) => {
            let setting
            if(state.tools[state.toolIndex] === undefined || (setting = state.toolsSetting[state.tools[state.toolIndex].direction]) === undefined) {
                return {
                    coinmarketcap_price: 0,
                    decimal_price: 2,
                    decimal_volume: 8,
                    max_volume: 50000,
                    min_volume: 0.0001,
                    fee_maker: 0,
                    fee_taker: 0,
                    is_default: true
                }
            }
            return setting
        },
        getCurrentToolLeverage: (state) => {
            if(state.tools[state.toolIndex] === undefined) {
                return null;
            }
            const direction = state.tools[state.toolIndex].direction;
            if( state.userDirectionSetting[direction] != undefined) {
                return state.userDirectionSetting[direction].leverage
            }
            let setting

            if((setting = state.toolsSetting[state.tools[state.toolIndex].direction]) !== undefined) {
                return setting.max_leverage
            }
            return null;
        },
        getFavoriteCurrencyList: (state) => state.favoriteCurrencyList,
        getListingTypes: (state) => {
            return [
                {
                    id: LISTING_TYPE_FIAT,
                    name: 'Forex'
                },
                {
                    id: LISTING_TYPE_CFD,
                    name: 'CFD'
                },
                {
                    id: LISTING_TYPE_CRYPTO,
                    name: 'Crypto'
                },
                {
                    id: LISTING_TYPE_COMMODY,
                    name: 'Commodities'
                }
            ]
        },
        getTradeReload:(state) => state.tradeReaload,
        getInjectCurrency:(state) => state.injectCurrency,
    },
}